import React, { memo } from 'react';
import { Button } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import AddIcon from '@mui/icons-material/AddCircleOutlineRounded';

const styles = theme => ({
    addButton: {
        marginTop: theme.spacing(1)
    }
});

const AddLayerButton = memo(({ disabled, classes, onClick }) => (
    <Button
        className={classes.addButton}
        startIcon={<AddIcon />}
        size='small'
        disabled={disabled}
        onClick={onClick}
    >
        Add Layer
    </Button>
));

export default withStyles(AddLayerButton, styles);

